import { Icon, Layout, Text } from '@loadsmart/miranda-react'

export type PasswordCheckItemProps = {
  showIcon: boolean
  text: string
  isValid: boolean
}

export function PasswordCheckItem({ showIcon, isValid, text }: PasswordCheckItemProps) {
  return (
    <Layout.Group gap="spacing-2" align="center">
      {showIcon && (
        <Icon
          aria-label="password-check-icon"
          name={isValid ? 'check' : 'close'}
          color={isValid ? 'color-success-60' : 'color-danger-60'}
          size="15"
        />
      )}
      <Text variant="body-md" color="color-text-tertiary">
        {text}
      </Text>
    </Layout.Group>
  )
}
